import * as Sentry from '@sentry/react';
import type { Extras } from '@sentry/types';

import { serializeError } from 'bundles/ai-coach-platform/utils/errors';

type Message = {
  error: unknown;
  source?: string;
  extra?: Extras;
  level?: Sentry.SeverityLevel;
  /**
   * Allows us to filter for errors on specific Coach modes
   */
  coachMode?: string;
  tags?: Record<string, string>;
};

/**
 * Capture messages in Sentry with the Coach prefix which enables us to filter for errors related to Coach
 * which we can target for slack alerts.
 */
export const captureMessageInSentry = ({
  error,
  source = '',
  extra = {},
  level = 'error',
  coachMode,
  tags = {},
}: Message) => {
  const sourceString = source ? `[${source}]` : '';

  try {
    Sentry.captureMessage(`[AiCourseCoach]: ${sourceString} ${serializeError(error)}`, {
      level,
      extra: {
        error,
        ...extra,
      },
      tags: {
        ...(coachMode && { coachMode }),
        ...tags,
      },
    });
  } catch {
    // eslint-disable-next-line no-console
    console.error('[AiCourseCoach]: Unable to capture this exception in Sentry', { error });
  }
};
